import React from 'react';
import styled from 'styled-components';

export interface FilterTagProps {
  children: React.ReactNode;
  onClear: () => void;
  className?: string;
}

const Root = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 8px;
  background: ${(p) => p.theme.colors.brand.primarySoft};
  border: 1px solid ${(p) => p.theme.colors.brand.primaryLine};
  border-radius: ${(p) => p.theme.radius.pill};
  color: ${(p) => p.theme.colors.brand.primary};
  font-family: ${(p) => p.theme.fontFamily.ui};
  font-size: ${(p) => p.theme.fontSize.xs};
  font-weight: ${(p) => p.theme.fontWeight.semibold};
  white-space: nowrap;
`;

const ClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: ${(p) => p.theme.fontSize.xs};
  line-height: 1;
  border-radius: 50%;

  &:hover {
    opacity: 0.7;
  }
`;

export function FilterTag({ children, onClear, className }: FilterTagProps) {
  return (
    <Root className={className}>
      {children}
      <ClearButton type="button" aria-label="Remove filter" onClick={onClear}>
        ×
      </ClearButton>
    </Root>
  );
}
